import React from 'react';

class News extends React.Component {
    componentDidMount() {

    }

    render() {
        var images = [
            './assets/images/news/news1.jpg',
            './assets/images/news/news2.jpg',
            './assets/images/news/news3.jpg'
        ]
        var list = (images.map(function (item) {
            return <img src={item} class='bigimage' />;
        }));

        var newcomplete = (
            <div class='fullwidthcontainer'>
                <div class='fullwidthcontainer'>
                    {list}
                </div>
                <div class='fullwidthcontainer'>
                    <div class='text center'>
                        [Hier kann ein Text eingefügt werden]
                    </div>
                </div>
            </div>
        );

        return newcomplete;
    }
}

export default (News);